import React, { useMemo, useState } from 'react'
import Countdown, { zeroPad } from 'react-countdown'
import { DateTimeNotification } from './styles'
import moment from 'moment'
import { notificationStatus } from 'constants/notificationStatus'
import { NotificationType } from 'types/notification'

interface props {
  color: string
  timer: string
  status: string
  containerStyle?: string
  notification: NotificationType
}

export const existCountdownWarningInterval = (deadline) => {
  let momentDeadline = moment(deadline)
  let now = moment()

  if (momentDeadline.valueOf() >= now.valueOf()) {
    let intervalTimer = momentDeadline.diff(now)
    var duration = moment.duration(intervalTimer)
    let days = duration.days()
    let milisecs = duration.milliseconds()
    return milisecs > 0 && days < 10
  }

  return false
}

export const textColorCountdown = (deadline) => {
  let days = getDays(deadline)
  if (days < 3) return 'text-[#DF8D2C] min-w-[120px] h[25px] mr-1'
  if (days < 5) return 'text-[#8AA15C] min-w-[120px] h[25px] mr-1'
  if (days < 7) return 'text-[#6190A4] min-w-[120px] h[25px] mr-1'
  if (days < 10) return 'text-[#517BBB] min-w-[120px] h[25px] mr-1'
}

let getDays = (deadline) => {
  let momentDeadline = moment(deadline)
  let now = moment()

  if (momentDeadline.valueOf() >= now.valueOf()) {
    let intervalTimer = momentDeadline.diff(now)
    var duration = moment.duration(intervalTimer)
    return duration.days()
  }
}

const getWarningColor = (deadline) => {
  let days = getDays(deadline)
  if (days < 3) return '#DF8D2C'
  if (days < 5) return '#8AA15C'
  if (days < 7) return '#6190A4'
  if (days < 10) return '#517BBB'
}

const Completionist = () => (
  <DateTimeNotification className="text-[#C43B51] mr-1 min-w-[64px]">
    Expirado
  </DateTimeNotification>
)
export const getStoppedTime = ({notification}:{ notification: NotificationType}): number => {
  let stoppedTime: number
  
  
  if (notification?.u_date_and_time_closed_by_manager?.value) {
    stoppedTime = new Date(notification?.u_date_and_time_closed_by_manager?.value).getTime() 
  } else if (notification?.u_date_and_hour_notification_closed?.value) {
    stoppedTime = new Date(notification?.u_date_and_hour_notification_closed?.value).getTime()
  } else if (notification?.u_date_and_hour_notification_closed?.display_value) {
    // Tentar com display_value se value não existir
    stoppedTime = new Date(notification?.u_date_and_hour_notification_closed?.display_value).getTime()
  } else if (notification?.u_date_and_time_closed_by_manager?.display_value) {
    // Tentar com display_value se value não existir
    stoppedTime = new Date(notification?.u_date_and_time_closed_by_manager?.display_value).getTime()
  } else {
    stoppedTime = new Date().getTime()
  }
  
  return stoppedTime
}
const closedSteps = ['5','4']
const CountdownNotification: React.FC<props> = ({ color, notification, timer, status, containerStyle = 'flex flex-row justify-end' }) => {

  const [clockCountdownColor, setClockCountdownColor] = useState<string>(color)
  const [hasCountdown, setHasCountdown] = useState<boolean>(true)
  
  // Verifica se o timer é válido (não é string vazia ou inválida)
  const isValidTimer = useMemo(() => {
    if (!timer || timer === '' || timer === 'undefined' || timer === 'null') {
      return false
    }
    const timerTime = new Date(timer).getTime()
    return !isNaN(timerTime)
  }, [timer])
  
  let hasExpiredTimer = useMemo(() => {
    if (!isValidTimer) {
      return false
    }
    
    const timerTime = new Date(timer).getTime()
    const currentTime = new Date().getTime()
    
    // Para notificações fechadas, verifica se foi finalizada DEPOIS do prazo
    if (closedSteps.includes(status)) {
      return getStoppedTime({notification}) > timerTime
    }
    
    // Para notificações ativas, compara com o tempo atual
    return timerTime <= currentTime
  }, [timer, status, notification, isValidTimer])

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    let clockColor =
      closedSteps.includes(status) ? hasExpiredTimer
        ? '#C43B51' : '#517BBB'
        : getWarningColor(timer)
    setClockCountdownColor(clockColor)

    if (completed) {
      setClockCountdownColor('#C43B51')
      return <Completionist />
    } else {
      if (
        (existCountdownWarningInterval(timer) && !closedSteps.includes(status)) ||
        (hasExpiredTimer && !closedSteps.includes(status))
      ) {
        setHasCountdown(true)
        return (
          <>
            {zeroPad(days, 1)} dias e {zeroPad(hours)}:
            {zeroPad(minutes)}:{zeroPad(seconds)}
          </>
        )
      }
    }
  }
  if (status === notificationStatus[5].value) {
    return <div className={`${containerStyle} mt-4`}></div>
  }
  
  // Se não há timer válido (sem SLA), não exibe countdown
  if (!isValidTimer) {
    return <div className={`${containerStyle} mt-4`}></div>
  }
  
  return (
    <div className={containerStyle}>
      {closedSteps.includes(status) ? (
        <>
          <div className='mr-1 mt-px'>
            <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.75 1.875V0.75H9.25V1.875H4.75ZM6.4375 10.2563H7.5625V5.94375H6.4375V10.2563ZM7 16.4813C6.075 16.4813 5.20312 16.3031 4.38437 15.9469C3.56562 15.5906 2.85 15.1063 2.2375 14.4938C1.625 13.8813 1.14063 13.1656 0.784375 12.3469C0.428125 11.5281 0.25 10.6562 0.25 9.73125C0.25 8.80625 0.428125 7.93438 0.784375 7.11563C1.14063 6.29688 1.625 5.58125 2.2375 4.96875C2.85 4.35625 3.56562 3.87188 4.38437 3.51562C5.20312 3.15937 6.075 2.98125 7 2.98125C7.8375 2.98125 8.625 3.12187 9.3625 3.40312C10.1 3.68437 10.7562 4.075 11.3312 4.575L12.2875 3.61875L13.075 4.40625L12.1188 5.3625C12.5688 5.8625 12.9531 6.46875 13.2719 7.18125C13.5906 7.89375 13.75 8.74375 13.75 9.73125C13.75 10.6562 13.5719 11.5281 13.2156 12.3469C12.8594 13.1656 12.375 13.8813 11.7625 14.4938C11.15 15.1063 10.4344 15.5906 9.61563 15.9469C8.79688 16.3031 7.925 16.4813 7 16.4813ZM7 15.3563C8.5625 15.3563 9.89062 14.8094 10.9844 13.7156C12.0781 12.6219 12.625 11.2937 12.625 9.73125C12.625 8.16875 12.0781 6.84062 10.9844 5.74687C9.89062 4.65312 8.5625 4.10625 7 4.10625C5.4375 4.10625 4.10938 4.65312 3.01562 5.74687C1.92188 6.84062 1.375 8.16875 1.375 9.73125C1.375 11.2937 1.92188 12.6219 3.01562 13.7156C4.10938 14.8094 5.4375 15.3563 7 15.3563Z"
                fill={!hasExpiredTimer ? ('#517BBB') : ('#C43B51')} />
            </svg>
          </div>
          <DateTimeNotification className={`text-[${!hasExpiredTimer ? ('#517BBB') : ('#C43B51')}]`}>
            {!hasExpiredTimer ? ("Dentro") : ("Fora")} do prazo
          </DateTimeNotification>
        </>
      ) : (
        <>
          {hasCountdown ? (<>
            <div className='mr-1 mt-px'>
              <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.75 1.875V0.75H9.25V1.875H4.75ZM6.4375 10.2563H7.5625V5.94375H6.4375V10.2563ZM7 16.4813C6.075 16.4813 5.20312 16.3031 4.38437 15.9469C3.56562 15.5906 2.85 15.1063 2.2375 14.4938C1.625 13.8813 1.14063 13.1656 0.784375 12.3469C0.428125 11.5281 0.25 10.6562 0.25 9.73125C0.25 8.80625 0.428125 7.93438 0.784375 7.11563C1.14063 6.29688 1.625 5.58125 2.2375 4.96875C2.85 4.35625 3.56562 3.87188 4.38437 3.51562C5.20312 3.15937 6.075 2.98125 7 2.98125C7.8375 2.98125 8.625 3.12187 9.3625 3.40312C10.1 3.68437 10.7562 4.075 11.3312 4.575L12.2875 3.61875L13.075 4.40625L12.1188 5.3625C12.5688 5.8625 12.9531 6.46875 13.2719 7.18125C13.5906 7.89375 13.75 8.74375 13.75 9.73125C13.75 10.6562 13.5719 11.5281 13.2156 12.3469C12.8594 13.1656 12.375 13.8813 11.7625 14.4938C11.15 15.1063 10.4344 15.5906 9.61563 15.9469C8.79688 16.3031 7.925 16.4813 7 16.4813ZM7 15.3563C8.5625 15.3563 9.89062 14.8094 10.9844 13.7156C12.0781 12.6219 12.625 11.2937 12.625 9.73125C12.625 8.16875 12.0781 6.84062 10.9844 5.74687C9.89062 4.65312 8.5625 4.10625 7 4.10625C5.4375 4.10625 4.10938 4.65312 3.01562 5.74687C1.92188 6.84062 1.375 8.16875 1.375 9.73125C1.375 11.2937 1.92188 12.6219 3.01562 13.7156C4.10938 14.8094 5.4375 15.3563 7 15.3563Z"
                  fill={clockCountdownColor} />
              </svg>
            </div>
            <DateTimeNotification className={textColorCountdown(timer)}>
              <Countdown
                date={timer}
                intervalDelay={0}
                precision={2}
                renderer={renderer}>
                <Completionist></Completionist>
              </Countdown>
            </DateTimeNotification>

          </>) : (<>
            <div>&nbsp;</div>
          </>)}
        </>
      )}
    </div>
  )
}

export default CountdownNotification
